module.exports.exportData = function(array) {
    const link = document.createElement('a');
    let csv = convertArrayOfObjectsToCSV(array);
    if (csv == null) return;
    const filename = 'export.csv';
    if (!csv.match(/^data:text\/csv/i)) {
      csv = `data:text/csv;charset=utf-8,${csv}`;
    }
    link.setAttribute('href', encodeURI(csv));
    link.setAttribute('download', filename);
    link.click();
};
module.exports.filterData = function(obj) {
  let val = document.getElementById('search_box').value
  let records = []
  if (obj.state['saved_data']) records = obj.state['saved_data'];
  else {
    records = obj.state['data'];
    obj.state['saved_data'] = records;
  }
  let filtered = records.filter( item => {
    let ret = false;
    const fields = ['name', 'publisher_name', 'site_name', 'placement_name', 'bidder_name', 'url', 'keywords', 'domain_name', 'match', 'ad_domains'];
    fields.forEach(x => {
      if (item[x]) {
        ret = ret || item[x].toLowerCase().includes(val.toLowerCase());
      }
    });
    return ret;
  });
  obj.setState({data: filtered})
}
// https://github.com/jbetancur/react-data-table-component/blob/master/stories/DataTable/Basic/ExportCSV.stories.js
function convertArrayOfObjectsToCSV(array) {
    let result;
    const columnDelimiter = ',';
    const lineDelimiter = '\n';
    const keys = Object.keys(array[0]);
    result = '';
    result += keys.join(columnDelimiter);
    result += lineDelimiter;
    array.forEach(item => {
      let ctr = 0;
      keys.forEach(key => {
        if (ctr > 0) result += columnDelimiter;
        let val = item[key];
        if (Array.isArray(val)) val = `"${val.join(',')}"`;
        else if (val && typeof(val) === 'string' && val.indexOf(',') >= 0) val = `"${val}"`;
        result += val;
        ctr++;
      });
      result += lineDelimiter;
    });
    return result;
}